import React from "react";

import { Beauticians } from "../beautician";
import { BeauticianBasicProfile } from "./beauticianBasicProfile";
import { Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
export function BeauticianEditProfile() {
     const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);
  return (
    <div className="matchMainContainer">
      <div className="matchEdit-subcontainer">
        <Link to="/beauticians"><div
          className="bi bi-arrow-left"
       
        ></div></Link>
        
        <div className="matchBasic-menu">
          <div>Basic Information</div>
        </div>
      </div>
      <div>
        <BeauticianBasicProfile userId={userId} />
      </div>
    </div>
  );
}
